import React from 'react'
import _ from 'lodash'
import { compose } from 'redux'
import { withFormik } from 'formik'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import config from '../../../config'
import Field from '../../views/widgets/Field'
import InputText from '../../views/widgets/InputText'
import { toast } from 'react-toastify'
import { createPortal } from '../../../modules/portal-remote/portalService'

const PortalCreateModal = ({
  onRequestClose,
  language,
  handleSubmit,
  handleChange,
  handleBlur,
  values,
  errors,
}) => (
  <div className="card">
    <header className="card-header">
      <p className="card-header-title"> Create New Portal</p>
    </header>
    <div className="card-content">
      <div className="content">
        <Field label={`Title[${_.toUpper(language)}]`}>
          <InputText
            name={`title.${language}`}
            placeholder="Enter your title"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.title[language]}
            error={errors.title && errors.title[language]}
          />
        </Field>
      </div>
    </div>
    <footer className="card-footer">
      <a className="card-footer-item" onClick={onRequestClose}>
        Cancel
      </a>
      <a className="card-footer-item" onClick={handleSubmit}>
        Create
      </a>
    </footer>
  </div>
)

export default compose(
  connect(({ info: { language } }) => ({ language })),
  withFormik({
    mapPropsToValues: () => {
      return {
        title: config.getLangText(),
      }
    },
    handleSubmit: async (values, { props, setSubmitting, setFieldError }) => {
      try {
        setSubmitting(true)
        // const result = {_id: "adb"}
        const result = await createPortal({ title: values.title })
        toast.success('Initial Portal...')
        if (props.onRequestClose) {
          props.onRequestClose({ portalID: result._id })
        }
        setSubmitting(false)
      } catch (error) {
        setSubmitting(true)
        toast.error('Portal Create Error: ' + error.message)
      }
    },
    validate: (values, { language }) => {
      const errors = {}
      if (!values.title[language]) {
        errors.title = {}
        errors.title[language] = 'Please fill title.'
      }
      console.log(errors)
      return errors
    },
    enableReinitialize: true,
    displayName: 'PortalCreateForm',
  }),
)(PortalCreateModal)



// WEBPACK FOOTER //
// ./src/components/templates/portal-create/PortalCreateModal.js